module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"planEnded":"You have exceeded the number of interviews in your plan.","planEndedText":"Upgrade your plan and see new applicants right now.","more":"More info"}}')
  delete Component.options._Ctor
}
